const config = {
  version: "20191029.1",
  apiurl: "/data.json",
  successtimeout: 36000,
  gtmAnalyticsId: "GTM-NV7TW74",
  analyticsId: "UA-132321687-1"
};
// GTM-PJ5XJHH
export default config;
